interface PDFCheckIconProps {
  className?: string
}

export const PDFCheckIcon: React.FC<PDFCheckIconProps> = ({
  className = "text-white",
}) => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M40.3331 4.92361L34.2521 11.0046L30.8159 7.55463L31.5796 6.78238L34.2521 9.4549L39.5469 4.15137L40.3331 4.92361Z"
      fill="white"
    />
    <path
      d="M16.3042 5V11.6678C16.3042 12.1099 16.4798 12.5338 16.7924 12.8465C17.105 13.1591 17.529 13.3347 17.9711 13.3347H24.6389"
      stroke="white"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.30518 20V8.33333C1.30518 7.44928 1.65637 6.60143 2.28149 5.97631C2.90661 5.35119 3.75445 5 4.63851 5H16.3052L24.6385 13.3333V20"
      stroke="white"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.3541 24.8674C26.3541 25.0974 26.2627 25.318 26.1 25.4807C25.9374 25.6433 25.7168 25.7347 25.4867 25.7347H21.7282V28.6259H24.3303C24.5603 28.6259 24.7809 28.7173 24.9436 28.8799C25.1062 29.0426 25.1976 29.2632 25.1976 29.4932C25.1976 29.7233 25.1062 29.9439 24.9436 30.1065C24.7809 30.2692 24.5603 30.3606 24.3303 30.3606H21.7282V32.9626C21.7282 33.1927 21.6368 33.4133 21.4742 33.576C21.3115 33.7386 21.0909 33.83 20.8608 33.83C20.6308 33.83 20.4102 33.7386 20.2475 33.576C20.0849 33.4133 19.9935 33.1927 19.9935 32.9626V24.8674C19.9935 24.6373 20.0849 24.4167 20.2475 24.254C20.4102 24.0914 20.6308 24 20.8608 24H25.4867C25.7168 24 25.9374 24.0914 26.1 24.254C26.2627 24.4167 26.3541 24.6373 26.3541 24.8674ZM7.27232 27.7585C7.27232 28.7554 6.87633 29.7114 6.17147 30.4162C5.46661 31.1211 4.51061 31.5171 3.51379 31.5171H2.0682V32.9626C2.0682 33.1927 1.97682 33.4133 1.81416 33.576C1.6515 33.7386 1.43089 33.83 1.20085 33.83C0.970813 33.83 0.750198 33.7386 0.587538 33.576C0.424878 33.4133 0.333496 33.1927 0.333496 32.9626V24.8674C0.333496 24.6373 0.424878 24.4167 0.587538 24.254C0.750198 24.0914 0.970813 24 1.20085 24H3.51379C4.51061 24 5.46661 24.396 6.17147 25.1008C6.87633 25.8057 7.27232 26.7617 7.27232 27.7585ZM5.53761 27.7585C5.53761 27.2218 5.32439 26.707 4.94485 26.3275C4.56531 25.9479 4.05054 25.7347 3.51379 25.7347H2.0682V29.7824H3.51379C4.05054 29.7824 4.56531 29.5691 4.94485 29.1896C5.32439 28.81 5.53761 28.2953 5.53761 27.7585ZM17.6806 28.915C17.6806 30.2185 17.1627 31.4687 16.241 32.3904C15.3192 33.3122 14.0691 33.83 12.7656 33.83H10.4526C10.2226 33.83 10.002 33.7386 9.8393 33.576C9.67664 33.4133 9.58526 33.1927 9.58526 32.9626V24.8674C9.58526 24.6373 9.67664 24.4167 9.8393 24.254C10.002 24.0914 10.2226 24 10.4526 24H12.7656C14.0691 24 15.3192 24.5178 16.241 25.4396C17.1627 26.3613 17.6806 27.6115 17.6806 28.915ZM15.9458 28.915C15.9458 28.0715 15.6108 27.2626 15.0144 26.6662C14.4179 26.0698 13.609 25.7347 12.7656 25.7347H11.32V32.0953H12.7656C13.609 32.0953 14.4179 31.7602 15.0144 31.1638C15.6108 30.5674 15.9458 29.7585 15.9458 28.915Z"
      fill="white"
    />
  </svg>
)
